import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { Outlet } from 'react-router-dom';

function Root() {
    return (
        <>
            <Navbar/>
            <ScrollToTop/>
            <main>
                <Outlet/>
            </main>
            <Footer/>
        </>
    );
}

export default Root;